import { useEffect, useRef } from "react";

const useNotification = () => {
  const permissionRef = useRef(Notification.permission);

  useEffect(() => {
    // Request permission on mount
    if (Notification.permission === "default") {
      Notification.requestPermission().then((perm) => {
        permissionRef.current = perm;
      });
    }
  }, []);

  const showNotification = (title, body, icon) => {
    // Only show if tab is not focused
    if (document.visibilityState === "visible") return;
    if (permissionRef.current !== "granted") return;

    try {
      const n = new Notification(title, {
        body,
        icon: icon || "/favicon-192.png",
        badge: "/favicon-32x32.png",
        tag: "chatify-message-" + Date.now(), // unique tag = shows every time
        renotify: false,
      });
      setTimeout(() => n.close(), 4000);
      n.onclick = () => { window.focus(); n.close(); };
    } catch (e) {
      console.warn("Notification failed:", e.message);
    }
  };

  return { showNotification };
};

export default useNotification;
